<template>
    <div>
        <v-dialog
            v-model="isOpen"
            max-width="600"
            @keydown.esc.prevent="close"
            persistent
            @click:outside="close"
            content-class="modalCopy"
        >
            <v-container>
                <v-layout row class="d-flex flex-column">
                    <h3 class="text-center text-uppercase pb-5 pt-5" style="background: #f5f5f5; margin-top: -12px;">Select Recipients</h3>
                    <v-flex class="d-flex justify-space-between" style="margin: 20px auto 0 auto;">
                        <div class="mb-2 mx-2" v-if="level === 'Personal'">
                            <h3 class="ma-0 mb-3">Employees *</h3>
                            <v-autocomplete
                                v-model="selectedEmployees"
                                :items="employees"
                                item-text="fullName"
                                item-value="id"
                                multiple
                                :search-input.sync="searchInputAutocomplete[selectInputConts.employee]"
                                @change="changeOption(selectInputConts.employee)"
                                dense
                                solo
                                lighten-1
                                placeholder="Employee"
                                label="Choose Employee"
                                style="max-width: 250px;"
                                height="30px"
                                class="font-weight-regular"
                            >
                                <template v-slot:selection="{ item, index }">
                                    <span v-if="index === 0" class="selection-text-style">{{ item.fullName }}</span>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text caption"
                                    >(+{{ taskInfo.employees.length - 1 }} others)</span>
                                </template>
                            </v-autocomplete>
                        </div>
                        <div class="mb-2 mx-2" v-else>
                            <h3 class="ma-0 mb-3">Clinics <span v-if="level === 'ClinicOrHQ'">*</span></h3>
                            <v-autocomplete
                                v-model="selectedClinics"
                                :items="clinics"
                                item-text="title"
                                item-value="id"
                                multiple
                                :search-input.sync="searchInputAutocomplete[selectInputConts.clinics]"
                                @change="changeOption(selectInputConts.clinics)"
                                dense
                                solo
                                lighten-1
                                placeholder="Clinic"
                                label="Choose Clinic"
                                style="max-width: 250px;"
                                height="30px"
                                class="font-weight-regular"
                            >
                                <template v-slot:selection="{ item, index }">
                                    <span v-if="index === 0" class="selection-text-style">{{ item.title }}</span>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text caption"
                                    >(+{{ clinics.length - 1 }} others)</span>
                                </template>
                            </v-autocomplete>
                        </div>
                        <div class="mb-2 mx-2" v-if="level === 'Surgery'">
                            <h3 class="ma-0 mb-3">Surgeries *</h3>
                            <v-autocomplete
                                v-model="selectedSurgeries"
                                :items="surgeries"
                                item-text="value"
                                item-value="id"
                                multiple
                                :search-input.sync="searchInputAutocomplete[selectInputConts.surgeries]"
                                @change="changeOption(selectInputConts.surgeries)"
                                dense
                                solo
                                lighten-1
                                placeholder="Surgeries"
                                label="Choose Surgeries"
                                style="max-width: 250px;"
                                height="30px"
                                class="font-weight-regular"
                            >
                                <template v-slot:selection="{ item, index }">
                                    <span v-if="index === 0" class="selection-text-style">{{ item.value }}</span>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text caption"
                                    >(+{{ surgeries.length - 1 }} others)</span>
                                </template>
                            </v-autocomplete>
                        </div>
                    </v-flex>
                    <v-flex class="d-flex justify-center mt-5">
                        <v-btn class="mr-4" @click="close">Cancel</v-btn>
                        <v-btn color="primary" :disabled="loading || isDisable" :loading="loading" @click="generateTask">Generate</v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-dialog>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import selectInputAutocomplete from '../../../constatns/selectInputAutocomplete'

export default {
    props: ['isOpen', 'level', 'employees', 'clinics', 'isAdhoc', 'taskInfo'],
    data: () => ({
        loading: false,
        selectedEmployees: [],
        selectedClinics: [],
        selectedSurgeries: [],
        selectInputConts: selectInputAutocomplete,
        searchInputAutocomplete: {
            [selectInputAutocomplete.employee]: null,
            [selectInputAutocomplete.clinics]: null,
            [selectInputAutocomplete.surgeries]: null
        }
    }),
    computed: {
        surgeries () {
            if (this.isAdhoc) {
                const surgery = this.$store.getters.getClinicSurgeries(this.$store.getters.getUserActiveClinic)
                surgery.forEach(item => {
                    item.clinicId = this.$store.getters.getUserActiveClinic
                })
                return surgery
            } else {
                return this.$store.getters.getSurgeriesByClinics(this.selectedClinics)
            }
        },
        isDisable () {
            if (this.level === 'ClinicOrHQ' && this.selectedClinics.length === 0) return true
            if (this.level === 'Personal' && this.selectedEmployees.length === 0) return true
            return this.level === 'Surgery' && this.selectedSurgeries.length === 0
        }
    },
    methods: {
        ...mapActions(['directTaskGeneration', 'showAlert']),
        close () {
            this.$emit('closeFilterPopup')
        },
        changeOption (typeSearch) {
            this.searchInputAutocomplete[typeSearch] = ''
        },
        async generateTask () {
            const data = {
                toGenerates: []
            }
            if (this.selectedEmployees.length) {
                this.selectedEmployees.forEach(employee => {
                    data.toGenerates.push({
                        employeeId: employee
                    })
                })
            }
            if (this.selectedClinics.length && this.level === 'ClinicOrHQ') {
                this.selectedClinics.forEach(clinic => {
                    data.toGenerates.push({
                        clinicId: clinic
                    })
                })
            }
            if (this.selectedSurgeries.length) {
                this.selectedSurgeries.forEach(surgery => {
                    data.toGenerates.push({
                        surgeryId: surgery
                    })
                })
            }
            if (this.taskInfo.id >= 0) {
                data.toGenerates.forEach(generateItem => {
                    generateItem.taskTemplateId = this.taskInfo.id
                })
            }
            try {
                this.loading = true
                const result = await this.directTaskGeneration(data)
                if (result) this.showAlert({ text: 'Generated successfully', type: 'success' })
                this.loading = false
            } catch (e) {
                this.loading = false
            }
        }
    }
}
</script>

<style lang="scss">
.modalCopy {
    background: #fff;
}

.filtersBlock {
    margin-top: 20px;
    padding: 0 30px;
}
</style>
